import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import formatDropdownOptions from 'utils/format-dropdown-options';
import { AppState } from 'services/types';

import { GroupId, GroupsState, GroupsProps } from './types';

const selectGroups = (state: AppState): GroupsState => state.groups;
const selectGroupId = (
    _state: AppState,
    { groupId }: GroupsProps
): GroupId | null | undefined => groupId;

const selectGroupsArray = createDeepEqualSelector(selectGroups, (groupsState) =>
    Object.values(groupsState)
);

const selectGroupIds = createDeepEqualSelector(selectGroups, (groupsState) =>
    Object.keys(groupsState).map(Number)
);

const selectGroup = createDeepEqualSelector(
    [selectGroups, selectGroupId],
    (groupsState, groupId) => (groupId ? get(groupsState, groupId) : undefined)
);

const selectGroupName = createDeepEqualSelector(selectGroup, (group) =>
    get(group, 'name')
);

const makeSelectGroupName = (): typeof selectGroupName => selectGroupName;

const selectGroupColor = createDeepEqualSelector(selectGroup, (group) =>
    get(group, 'color')
);

const makeSelectGroupColor = (): typeof selectGroupColor => selectGroupColor;

const selectGroupOptions = createDeepEqualSelector(selectGroups, (groups) =>
    formatDropdownOptions(groups, {
        keyField: 'id',
        textField: 'name'
    })
);

export {
    selectGroupsArray,
    selectGroupIds,
    selectGroups,
    selectGroupId,
    selectGroup,
    makeSelectGroupName,
    makeSelectGroupColor,
    selectGroupOptions
};
